import { IYxInputPropTypes } from "./basePropType";
import PropType from "prop-types";

export const IcheckboxPropTypes = {
  ...IYxInputPropTypes,
  //控件类型group-分组,""-单个
  type: PropType.oneOf(["", "group"]),
  //分组数据
  data: PropType.array,
};

export const checkboxDefaultProps = () => ({
  inputParam: {},
  children: "", //子节点,子节点暂时只支持antd的Checkbox
  type: "group", //类型，分组模式
  data: [], //分组的数据
  rules: {},
  styleParam: {
    size: "default", //大小
    type: "default", //类型
  },
});



// WEBPACK FOOTER //
// ./src/yx-widget/component/YxInput/IpropType/checkboxPropType.js